import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function AuthNotConfiguredNotice() {
  const { t } = useTranslation(["auth"]);
  return (
    <div className="flex min-h-[100dvh] flex-col justify-center bg-[var(--background)] px-4 py-12">
      <div className="mx-auto max-w-md">
        <div className="rounded-[var(--r-lg)] border border-[color:color-mix(in_srgb,var(--risk-medium)_35%,transparent)] bg-[var(--card)] p-8 text-center">
          <span className="inline-flex rounded-full border border-[color:color-mix(in_srgb,var(--risk-medium)_35%,transparent)] bg-[color:color-mix(in_srgb,var(--risk-medium)_10%,var(--card))] px-4 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-[var(--foreground)]">
            {t("auth:firebase.setupBadge")}
          </span>
          <h2 className="mt-5 text-2xl font-semibold tracking-tight text-[var(--foreground)]">
            {t("auth:firebase.notConfigured")}
          </h2>
          <p className="mt-3 text-sm leading-6 text-[var(--muted-foreground)]">
            {t("auth:firebase.notConfiguredMessage")}
          </p>
          <div className="mt-6">
            <Button
              variant="cta"
              size="lg"
              className="w-full"
              render={<Link to="/settings" />}
            >
              {t("auth:firebase.goToSettings")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
